import { cbor_encode, cbor_decode } from 'cbor-codec/esm/index.mjs'

const cbor_codec = @{}
  name: 'CBOR'
  encode: pvec => cbor_encode(pvec)
  decode: u8 => cbor_decode(u8)

export function cbor_codec_plugin() ::
  return hub => ::
    hub._root_.as_stream_codec(cbor_codec)

